<template>
  <div>
    <SSelect
          :label="label"
          v-model="selected"
          :source="options"
          resultsDisplay="label"
          resultsValue="label"
          @selected="input"
          :autocomplete="false"
          @clear="clear($event)"
        />
  </div>
</template>

<script>
import SSelect from "./SSelect.vue"
export default {
  name: "SSort",
  data() {
    return {
      selected:  null,
    };
  },
  props: {
    options:{Type: Array},
    selectedOption:{},
    label:{
      type: String,
      default:"SORT BY"
    }

  },
  methods: {
    clear($event){
      this.$emit("clear");

    },
    input(val) {
      // console.log(val)
        this.$emit("input",val.value);
    },
  },
  components:{
    SSelect,
  },
  created() {
    this.selected = this.selectedOption;
  },
};
</script>

<style lang="scss" scoped>
.mr-16 {
  margin-right: 16px;
}
.text {
    font-family: "Roboto !important";
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: #000000;
  text-transform: capitalize;
}
label {
  font-weight: bold;
  font-size: 12px;
  text-transform: capitalize !important;
}
select {
  font-size: 10px;
  border: solid 1px var(--very-light-pink);
  background: #ffffff;
  padding: 8px 80px 8px 16px;
}
</style>